import { useAppDispatch } from '@/store/store';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

import { Switch } from '@headlessui/react';
import { setChangeProccess } from '@/store/slices/claimsSlice';

const ClaimsSwitch = () => {
  const dispatch = useAppDispatch();

  const enabled = useSelector((state: RootState) => state.claims.isProcess);
  const { importing } = useSelector((state: RootState) => state.import);

  return (
    <div className="flex items-center space-x-6 mb-5">
      <span
        className={`text-base font-jostExtraBold font-semibold ${
          !enabled ? 'text-gray-900' : 'text-gray-500'
        }`}>
        MANGLER INFORMATION
      </span>
      <Switch
        checked={enabled}
        onChange={(val) => dispatch(setChangeProccess(val))}
        disabled={importing}
        className={`relative inline-flex w-16 h-4 items-center rounded-full bg-[#8CA2CE] transition-colors 
          ${importing ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
        <span
          className={`${enabled ? 'translate-x-12' : '-translate-x-2'}
            inline-block w-[26px] h-[26px] transform rounded-full bg-[#1F2B40] transition`}
        />
      </Switch>
      <span
        className={`text-base font-jostExtraBold font-semibold ${
          enabled ? 'text-gray-900' : 'text-gray-500'
        }`}>
        START RYKKERPROCES
      </span>
    </div>
  );
};

export default ClaimsSwitch;
